import React, { useState, useEffect, useRef } from 'react';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import axios from 'axios';
import '../custom.css';

const TaxPercent = () => {
    const toast = useRef(null);
    const inputRef = useRef(null);

    const [taxPercent, setTaxPercent] = useState('');
    const [taxes, setTaxes] = useState([]);
    const [editingTax, setEditingTax] = useState(null);
    const [globalFilter, setGlobalFilter] = useState("");

    useEffect(() => {
        fetchTaxes();
    }, []);

    const fetchTaxes = async () => {
        try {
            const res = await axios.get('https://treatway.co.in/Counter-Backend/api/server_masters/list/taxpercent');
            setTaxes(res.data);
        } catch (err) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch Tax' });
        }
    };

    const handleSave = async () => {
        try {
            let res;
            if (editingTax) {
                res = await axios.post('https://treatway.co.in/Counter-Backend/api/server_masters/save/taxpercent', { id: editingTax.taxId, name: taxPercent });
            } else {
                res = await axios.post('https://treatway.co.in/Counter-Backend/api/server_masters/save/taxpercent', { name: taxPercent });
            }

            if (res.data.status === 'success') {
                toast.current.show({
                    severity: 'success',
                    summary: editingTax ? 'Updated' : 'Added',
                    detail: editingTax
                        ? 'Tax updated successfully'
                        : 'Tax added successfully',
                });
                setTaxPercent('');
                setEditingTax(null);
                fetchTaxes();
            } else {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: res.data.message || 'Failed to save tax',
                });
                setTaxPercent('');
                setTimeout(() => inputRef.current?.focus(), 0);
            }
        } catch (err) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to save tax',
            });
        }
    };


    const confirmSave = () => {
        if (taxPercent === '' && taxPercent !== 0) {
            toast.current.show({
                severity: 'warn',
                summary: 'Warning',
                detail: 'Tax percent is required',
            });
            return;
        }

        confirmDialog({
            message: editingTax
                ? 'Are you sure you want to update this tax?'
                : 'Are you sure you want to add this tax?',
            header: editingTax ? 'Confirm Update' : 'Confirm Add',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Yes',
            rejectLabel: 'No',
            acceptClassName: 'p-button-success',
            rejectClassName: 'p-button-secondary',
            accept: () => handleSave(),
        });
    };


    const handleEdit = (rowData) => {
        setEditingTax(rowData);
        setTaxPercent(rowData.tax_percentage);

        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.focus();
            }
        }, 0);
    };

    const confirmCancel = () => {
        confirmDialog({
            message: 'Are you sure you want to cancel editing?',
            header: 'Confirm Cancel',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Yes',
            rejectLabel: 'No',
            acceptClassName: 'p-button-danger',
            rejectClassName: 'p-button-secondary',
            accept: () => {
                setEditingTax(null);
                setTaxPercent('');
            }
        });
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <Button icon="pi pi-pencil" className="p-button-rounded p-button-warning mr-2" onClick={() => handleEdit(rowData)} />
        );
    };

    return (
        <>
            <ConfirmDialog />
            <Toast ref={toast} />
            <h2 className="text-xl font-bold mb-4">Tax</h2>

            <div className="card">
                {/* Add / Edit Form */}
                <div className="flex flex-wrap align-items-end gap-3 mb-4">
                    <InputText
                        ref={inputRef}
                        value={taxPercent}
                        onChange={(e) => setTaxPercent(e.target.value)}
                        placeholder="Enter Tax"
                        style={{ width: '250px' }}
                    />
                    <Button
                        label={editingTax ? 'Update' : 'Save'}
                        icon="pi pi-save"
                        className="p-button-success"
                        onClick={confirmSave}
                    />
                    {editingTax && (
                        <Button
                            label="Cancel"
                            icon="pi pi-times"
                            className="p-button-secondary"
                            onClick={confirmCancel}
                        />
                    )}
                </div>
            </div>

            <div className="card">
                <div className="flex flex-wrap justify-between items-center mb-4 gap-3">
                    <div className="flex items-center ml-auto min-w-[250px] justify-end w-full sm:w-auto">
                        <span className="p-input-icon-left w-full">
                            <i className="pi pi-search"></i>
                            <InputText
                                value={globalFilter}
                                onChange={(e) => setGlobalFilter(e.target.value)}
                                placeholder="Search..."
                                className="p-inputtext-sm w-full"
                            />
                        </span>
                    </div>
                </div>

                <DataTable
                    value={taxes}
                    showGridlines
                    paginator
                    rows={10}
                    rowsPerPageOptions={[10, 25, 50]}
                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                    tableStyle={{ minWidth: '50rem' }}
                    className="p-datatable-sm"
                    globalFilter={globalFilter}
                >
                    <Column field="taxId" header="ID" />
                    <Column field="tax_percentage" header="Tax Percent" />
                    <Column header="Edit" body={actionBodyTemplate} />
                </DataTable>
            </div>
        </>
    );
};

export default TaxPercent;
